import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Emulator 接続（開発環境のみ）
if (import.meta.env.DEV && import.meta.env.VITE_FIREBASE_EMULATOR) {
  connectAuthEmulator(auth, "http://localhost:9099");
}
